import { memo, useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import classes from './override.module.scss';
import { CircularProgress } from '@material-ui/core';
import { convertHalfToFull, convertFullToHalf } from 'common/CharacterConverter';
import { useForgotId } from 'hooks/UseForgotId';
import ReCAPTCHA from 'react-google-recaptcha';
import { RoutePath } from 'consts/RoutePath';

type Props = {};
export type ForgotIdForm = {
	lastname: string;
	firstname: string;
	mailaddress: string;
};

export const ForgotIdTemplate = memo((_props: Props) => {
	const [formData, setFormData] = useState<ForgotIdForm>({
		lastname: '',
		firstname: '',
		mailaddress: '',
	});
	const {
		requestId,
		formErrors,
		isFormError,
		actionError,
		isActionError,
		processLoading,
		isCompleteButtonDisabled,
		recaptchaRef,
		onRecaptchaChange,
	} = useForgotId(formData);

	const handleChangeValue = (event: React.ChangeEvent<HTMLInputElement>) => {
		setFormData({ ...formData, [event.target.name]: event.target.value });
	};
	const handleBlurConvertHalfToFullValue = (event: React.FocusEvent<HTMLInputElement>) => {
		setFormData((prev) => ({ ...prev, [event.target.name]: convertHalfToFull(event.target.value) }));
	};
	const handleBlurConvertFullToHalfValue = (event: React.FocusEvent<HTMLInputElement>) => {
		setFormData((prev) => ({ ...prev, [event.target.name]: convertFullToHalf(event.target.value) }));
	};

	const scrollRef = useRef(null);
	useEffect(() => {
		scrollRef.current.scrollIntoView();
		document.title = 'GakkenID忘れ';
	}, []);

	const errorRef = useRef(null);
	useEffect(() => {
		if (isFormError || isActionError) {
			errorRef.current.scrollIntoView();
		}
	}, [formErrors, actionError]);

	return (
		<>
			<section className="section">
				<div className="section-in" ref={scrollRef}>
					<div className="section-head">GakkenID忘れ</div>

					{isFormError || isActionError ? (
						<div className="error-box" ref={errorRef}>
							{isActionError ? <p>{actionError}</p> : null}
							{isFormError ? (
								<>
									<p>※下記項目は全て必須となります。</p>
									<div className="error-box-in">
										{formErrors.lastname !== '' || formErrors.firstname !== '' ? (
											<p>【お名前】{formErrors.lastname || formErrors.firstname}</p>
										) : null}
										{formErrors.mailaddress !== '' ? <p>【メールアドレス】{formErrors.mailaddress}</p> : null}
										{formErrors.isNotRobot !== '' ? <p>【ロボット確認】{formErrors.isNotRobot}</p> : null}
									</div>
								</>
							) : null}
						</div>
					) : null}

					<div className="form-box">
						<div className="form-head">
							<label htmlFor="">メールアドレス</label>
							<span className="required">必須</span>
						</div>
						<div className="form-input">
							<input
								type="text"
								name="mailaddress"
								value={formData.mailaddress}
								onChange={handleChangeValue}
								onBlur={handleBlurConvertFullToHalfValue}
							/>
						</div>
						<p className="error">{formErrors.mailaddress}</p>
					</div>

					{/* 氏名 */}
					<div className="form-box">
						<div className="form-head">
							<label htmlFor="">お名前（全角）</label>
							<span className="required">必須</span>
							<span className="annotation">※全角</span>
						</div>
						<div className="form-input width50">
							<input
								type="text"
								name="lastname"
								placeholder="姓"
								value={formData.lastname}
								onChange={handleChangeValue}
								onBlur={handleBlurConvertHalfToFullValue}
							/>
						</div>
						<p className="error">{formErrors.lastname}</p>
						<div className="form-input width50">
							<input
								type="text"
								name="firstname"
								placeholder="名"
								value={formData.firstname}
								onChange={handleChangeValue}
								onBlur={handleBlurConvertHalfToFullValue}
							/>
						</div>
						<p className="error">{formErrors.firstname}</p>
					</div>

					<div className="recaptcha-box">
						<p>機械による不正登録を防ぐために『私はロボットではありません』にチェックをしてください。</p>
						<div className="recaptcha">
							<ReCAPTCHA
								ref={recaptchaRef}
								onChange={onRecaptchaChange}
								sitekey={process.env.REACT_APP_RECAPTCHA_DATA_SITEKEY}
							/>
						</div>
					</div>
					<div className={classes.forgotIdLinkDiv}>
						こちらにて解決されない場合は、
						<a
							href="https://contact.gakken.jp/user/op_enquete.gsp?sid=1035&mid=000111yf&hid=i0D6Wk2R4_0"
							target="_blank"
						>
							GakkenID事務局
						</a>
						へお問い合わせください。
					</div>
					<div className="btn-box">
						{processLoading ? (
							<CircularProgress />
						) : (
							<>
								<div className="btn wh">
									<Link to={RoutePath.LOGIN}>戻る</Link>
								</div>
								<div className="btn gr">
									<button
										className={isCompleteButtonDisabled ? classes.disabled : ''}
										onClick={requestId}
										disabled={isCompleteButtonDisabled}
									>
										送信
									</button>
								</div>
							</>
						)}
					</div>
				</div>
			</section>
		</>
	);
});
